import { useGetMainSearchQuery } from '@/app/(main)/search/hooks/useGetMainSearchQuery';
import { goToSearchDetails } from '@/app/(main)/search/utils/goToSearchDetailsPath';
import { SEARCH_CATEGORIES } from '@/consts/search-const';
import type { GlobalSearchCategory, GlobalSearchClientsItem } from '@/types/globalSearchApiTypes';
import { CategoryWrapper } from '../CategoryWrapper';
import { ClientsItem } from '../ClientsItem';

interface ClientsCategoryProps {
  data: GlobalSearchCategory<GlobalSearchClientsItem>;
}

export const ClientsCategory = ({ data }: ClientsCategoryProps) => {
  const { search } = useGetMainSearchQuery();

  return (
    <CategoryWrapper
      categoryName="Clients"
      itemsCount={data.count}
      isShowCount={false}
      redirectToDetails={goToSearchDetails({ category: SEARCH_CATEGORIES.CLIENTS, searchQuery: search })}
    >
      {data.results.map((item, index) => (
        <ClientsItem key={index} item={item} />
      ))}
    </CategoryWrapper>
  );
};